// ErrorPage.js
import React from 'react';
import { useRouteError, Link } from 'react-router-dom';

const ErrorPage = () => {
    const error = useRouteError(); // Access the error information
    console.error(error); // Log the error for debugging

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
            <Link to="/">Go back to Home</Link>
        </div>
    );
};

export default ErrorPage;
